import Udesk from 'Udesk';
import React from 'react';
import { Redirect } from 'react-router-dom';
import LayoutMenu from 'Component/common/layout-menu';
import { getCurrentRouteName } from 'Udesk/system/subApp';
import UdeskLocales from 'UdeskLocales';

class dataAnalysis extends React.Component {
    isRedirect(currentPath, toPath) {
        if (currentPath === toPath) {
            return true;
        }
        return false;
    }

    render() {
        let { route, location, sdkOptions } = this.props;

        let { locales } = this;

        let navLists = [];

        // 根据当前用户权限，组装菜单列表

        // 统计概况
        if (Udesk.data.init.user && Udesk.data.init.user.hasFeature('smart:statistical:overview')) {
            navLists.push({
                text: /* 统计概况 */UdeskLocales['current'].pages.conversationAnalysisDataAnalysis.statisticalOverview,
                pathName: getCurrentRouteName('statisticalProfile'),
                isActive: (match, location) => {
                    return location.pathname.includes('/statistical-profile');
                },
            });
        }

        // 舆情分析
        if (Udesk.data.init.user && Udesk.data.init.user.hasFeature('smart:discovery:root')) {
            navLists.push({
                text: /* 舆情分析 */UdeskLocales['current'].pages.conversationAnalysisDataAnalysis.publicOpinionAnalysis,
                pathName: 'conversationAnalysisSentimentAnalysis',
                isActive: (match, location) => {
                    return location.pathname.includes('/public-sentiment');
                },
            });
        }

        // 用户洞察
        if (Udesk.data.init.user && Udesk.data.init.user.hasFeature('smart:user:insight')) {
            navLists.push({
                text: /* 用户洞察 */UdeskLocales['current'].pages.conversationAnalysisDataAnalysis.userInsights,
                pathName: getCurrentRouteName('userInsight'),
                isActive: (match, location) => {
                    return location.pathname.includes('/user-insight');
                },
            });
        }

        // 产品洞察
        if (Udesk.data.init.user && Udesk.data.init.user.hasFeature('smart:product:insight')) {
            navLists.push({
                text: /* 产品洞察 */UdeskLocales['current'].pages.conversationAnalysisDataAnalysis.productInsights,
                pathName: getCurrentRouteName('productInsight'),
                isActive: (match, location) => {
                    return location.pathname.includes('/product-insight');
                },
            });
        }

        // 产品统计
        if (Udesk.data.init.user && Udesk.data.init.user.hasFeature('smart:product:statistics')) {
            navLists.push({
                text: /* 产品统计 */UdeskLocales['current'].pages.conversationAnalysisDataAnalysis.productStatistics,
                pathName: getCurrentRouteName('productStatistics'),
                isActive: (match, location) => {
                    return location.pathname.includes('/product-statistics');
                },
            });
        }

        // 竞品分析
        if (Udesk.data.init.user && Udesk.data.init.user.hasFeature('competing:analysis:root')) {
            navLists.push({
                text: /* 竞品分析 */ UdeskLocales['current'].pages.conversationAnalysisDataAnalysis
                    .competitionAnalysis,
                pathName: 'conversationAnalysisCompetitiveProductAnalysis',
                isActive: (match, location) => {
                    return location.pathname.includes('/competitive-product-analysis');
                },
            });
        }

        // 业务分析
        if (Udesk.data.init.user && Udesk.data.init.user.hasFeature('smart:analysis:root')) {
            navLists.push({
                text: locales.components.pages.businessAnalysis.title,
                pathName: getCurrentRouteName('businessAnalysisList'),
                isActive: (match, location) => {
                    return location.pathname.includes('/business-analysis');
                },
            });
        }

        // 社媒舆情
        if (Udesk.data.init.user && Udesk.data.init.user.hasFeature('smart:analysis:root')) {
            navLists.push({
                text: /* 社媒舆情 */UdeskLocales['current'].pages.conversationAnalysisDataAnalysis.socialMediaPublicOpinion,
                pathName: getCurrentRouteName('socialMediaSentiment'),
                isActive: (match, location) => {
                    return location.pathname.includes('/social-media-sentiment');
                },
            });
        }

        if (
            sdkOptions.props.landingPath != null &&
            this.isRedirect(route.path, location.pathname)
        ) {
            let toPath = location.pathname + sdkOptions.props.landingPath;
            return <Redirect to={toPath} sdkOptions={sdkOptions} />;
        } else if (navLists.length > 0 && this.isRedirect(route.path, location.pathname)) {
            let toPath = Udesk.ui.routing.getRouteFirstBottomedChildRoutePath({
                routeName: navLists[0].pathName,
            });
            return <Redirect to={toPath} sdkOptions={sdkOptions} />;
        } else {
            return (
                <div className="semantic-intelligence">
                    <LayoutMenu {...this.props} navLists={navLists} menuTitle={/* 数据分析 */UdeskLocales['current'].pages.conversationAnalysisDataAnalysis.dataAnalysis} />
                </div>
            );
        }
    }
}

export default Udesk.react.udeskify(dataAnalysis);
